import {
  CONSIGNMENT_OPTIONS_FAIL,
  CONSIGNMENT_OPTIONS_REQUEST,
  CONSIGNMENT_OPTIONS_RESET,
  CONSIGNMENT_OPTIONS_SUCCESS
} from '@/constants/consignmentConstants'

export const consignmentOptionsReducer = (state = { loading: false, options: [] }, action) => {
  switch (action.type) {
    case CONSIGNMENT_OPTIONS_REQUEST:
      return { loading: true, options: [] }
    case CONSIGNMENT_OPTIONS_SUCCESS:
      return { loading: false, options: action.payload }
    case CONSIGNMENT_OPTIONS_FAIL:
      return { loading: false, error: action.payload, options: [] }
    case CONSIGNMENT_OPTIONS_RESET:
      return { loading: false, options: [] }
    default:
      return state
  }
}
